export class FormValidationIdentifier {
    static NotNull = 'NotNull';

    constructor() {

    }
}


// WEBPACK FOOTER //
// ./src/waferJS/Form/Validation/FormValidationIdentifier.js